import { render, staticRenderFns } from "./previewFile.vue?vue&type=template&id=0b53c983&"
import script from "./previewFile.vue?vue&type=script&lang=js&"
export * from "./previewFile.vue?vue&type=script&lang=js&"
import style0 from "./previewFile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports